import "./MozaMethod.module.css";
import Navigation from "@/reusable_sections/Header";
import KitchenOrigins from "./sections/KitchenOrigins";
import TheJunkDaddyDifference from "./sections/TheJunkDaddyDifference";
import ExpertOpinion from "./sections/ExpertOpinion";
import Footer from "@/reusable_sections/Footer";
export default function MozaMethodPage() {
  return <div>
      <Navigation />
      <KitchenOrigins />
      <TheJunkDaddyDifference />
      <ExpertOpinion />
      <Footer />
    </div>;
}